module.exports = __webpack_public_path__ + "6d0e5d38fc9431a5fdf6b01ce5c7bfad.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room1/audio1/01_MCA-Meditation-for-Suburb-Brain.ogg
// module id = 765
// module chunks = 0